import { gql } from '../../../__generated__';

export const UPDATE_AND_SUBMIT_ANNOTATION = gql(`
    mutation UpdateAndSubmitAnnotationWeb($data: UpdateAnnotationWebInput!, $floorPlanId: ID!) {
    updateAndSubmitAnnotationWeb(data: $data, floorPlanId: $floorPlanId) {
      status
    }
    }
`);
